// src/AudioSpectrum/effects/gradientBars.js
import { getHSLColor } from '../colorUtils.js';

export const drawGradientBars = (ctx, frequencyData, width, height) => {
  const barCount = Math.min(frequencyData.length / 2, 128);
  const barWidth = width / barCount;
  
  ctx.clearRect(0, 0, width, height);
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const barHeight = (value / 255) * height;
    
    // 그라디언트 생성
    const gradient = ctx.createLinearGradient(0, height - barHeight, 0, height);
    const hue = (i / barCount) * 360;
    gradient.addColorStop(0, getHSLColor(hue, 100, 70));
    gradient.addColorStop(1, getHSLColor(hue, 100, 30));
    
    ctx.fillStyle = gradient;
    ctx.fillRect(i * barWidth, height - barHeight, barWidth - 2, barHeight);
  }
};